import React from 'react'
import './project.css'

import { Data } from '../ProjectData/Data'

const Project = () => {
  return (
    <div className='container'>
        {Data.map((val,key) => {
            return(
        <div className='card' key={key}>
            <div className='face face1'>
                <div className='content' >
                    <img src={val.img}
                    alt={val.title}/> 
                    <h3>{val.title}</h3>  
                </div>
            </div>
            <div className='face face2'>
                <div className='content'>
                    <p>
                       {val.text}
                    </p>
                    <a href={val.link} target="_blank" rel="noreferrer noopener"
                    >Website</a>
                </div>
            </div>
    </div>
            )
        })}
    </div>
  )
}

export default Project;